import { render, staticRenderFns } from "./ChangeLocale.vue?vue&type=template&id=33f8c3d1"
import script from "./ChangeLocale.vue?vue&type=script&lang=js"
export * from "./ChangeLocale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports